import { createApp } from "vue";
import { plugin, defaultConfig } from "@formkit/vue";
import { createPinia } from "pinia";
import App from "./App.vue";
import router from "./router";
import "./index.css";
import { formKitTheme } from "./theme/theme";

const pinia = createPinia();

createApp(App).use(router).use(pinia).use(plugin, defaultConfig(formKitTheme)).mount("#app");
